import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Cookies from 'universal-cookie';
import SimpleReactValidator from 'simple-react-validator';

import HeaderText from '../../components/communal/HeaderText';
import InteractionTimeout from '../../components/communal/InteractionTimeout';
import SetTitle from '../../components/communal/SetTitle';
import DestinationSwitch from '../../utilities/generic/DestinationSwitch';

import { generateId, formatDate } from '../../utilities/generic/Common.js'

class GroupArrival extends Component {
  constructor(props) {
    super(props);

    this.validator = new SimpleReactValidator();

    this.handleChange = this.handleChange.bind(this);
    this.handleBoolean = this.handleBoolean.bind(this);
    this.handleNestedChange = this.handleNestedChange.bind(this);
    this.handleAddPerson = this.handleAddPerson.bind(this);
    this.handleRemovePerson = this.handleRemovePerson.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  state = {
    skip: null,
    people: [
      {first_name: "", last_name: ""},
      {first_name: "", last_name: ""},
      {first_name: "", last_name: ""},
    ],

    validDetails: false,
    errors: "",
    error: "",
  }

  handleBoolean(event) {
    const name = event.target.name;
    const bool = event.target.value === "true"

    this.setState({[name]: bool});
  }

  handleChange(event) {
    const name = event.target.name;
    const value = event.target.value;

    this.setState({[name]: value});
  }

  handleNestedChange(event) {
    const name = event.target.name;
    const value = event.target.value;
    const index = event.target.dataset.index;

    const people = [...this.state.people];
    people[index][name] = value;

    this.setState({ people });
  };

  handleAddPerson() {
    this.setState(prevState => ({
      people: [...prevState.people, {first_name: "", last_name: ""}],
    }));
  };

  handleRemovePerson(event) {
    const index = event.target.dataset.index

    const people = [...this.state.people];
    people.splice(index, 1);

    this.setState({ people });
  };

  handleSubmit(event) {
    const people = this.removeEmptyPeople(this.state.people)
    if (people.length === 0) {
      // No people means they removed all the rows. They probably didn't mean to click "Yes".
      // Let them through to the next page without rendering form errors.
      this.setState({validDetails: true})
    }
    else if (this.validator.allValid()) {
      const profile_id = this.props.location.state.profile.id
      const type_of_person = this.props.location.state.profile.type_of_person
      const arriving_app_id = this.props.location.state.arriving_app_id

      people.forEach((person, index) => {
        const group_arrival = {
          first_name: person.first_name,
          last_name: person.last_name,
          type_of_person: type_of_person,
          profile_id: profile_id,
          app_id: generateId(),
          group_app_id: arriving_app_id,
          check_in_time: formatDate(new Date()),
          version: process.env.REACT_APP_COMMIT_HASH
        }

        const group_arrivals = JSON.parse(localStorage.getItem("group_arrivals")) || []
        group_arrivals.push(group_arrival)

        localStorage.setItem("group_arrivals", JSON.stringify(group_arrivals))

        this.setState({validDetails: true})
      })
    }
    else {
      this.validator.showMessages();
      this.forceUpdate();
    }

    event.preventDefault();
  }

  removeEmptyPeople(people) {
    return people.filter(this.notEmptyPerson)
  }

  notEmptyPerson(person) {
    return person.first_name.trim().length + person.last_name.trim().length > 0
  }

  renderGroupCheck() {
    if (this.state.skip === null) {
      return (
        <div className="content">
          <div className="widget form">
            <div className="message">
              Are you arriving with people?
            </div>

            <button className="widget button margin-right" name="skip" value="false" onClick={this.handleBoolean}>Yes</button>
            <button className="widget button" name="skip" value="true" onClick={this.handleBoolean}>No</button>
          </div>
        </div>
      )
    }
  }

  renderGroupArrivalForm(submit_button_value) {
    if (this.state.skip === false) {
      return (
        <div className="content">
          <div className="widget form">
            <form autoComplete="off" onSubmit={this.handleSubmit}>
              <div className="message">
                Please enter the people you are arriving with
              </div>

              <div className="grid-container">
                <div className="text">First Name</div>
                <div className="text">Last Name</div>
                <div></div>

                {this.state.people.map((person, index) => (
                  <React.Fragment key={index}>
                    <div className="grid-cell">
                      <input aria-required="true" type="text" data-index={index} name="first_name" value={person.first_name} autoComplete={"off"} onChange={this.handleNestedChange} />
                      {this.notEmptyPerson(person) && this.validator.message('first_name', person.first_name, "required|string", { className: 'error' })}
                    </div>

                    <div className="grid-cell">
                      <input aria-required="true" type="text" data-index={index} name="last_name" value={person.last_name} autoComplete={"off"} onChange={this.handleNestedChange} />
                      {this.notEmptyPerson(person) && this.validator.message('last_name', person.last_name, "required|string", { className: 'error' })}
                    </div>

                    <button className="widget button small-button" type="button" data-index={index} onClick={this.handleRemovePerson}>Remove</button>
                  </React.Fragment>
                ))}
              </div>

              <div className="add-person">
                <button className="widget button small-button" type="button" onClick={this.handleAddPerson}>Add Person +</button>
              </div>

              <input type="submit" value={submit_button_value} />
            </form>
          </div>
        </div>
      )
    }
  }

  render() {
    const cookies = new Cookies()
    const token = cookies.get('device_token')

    if (token === undefined) {
      return <Redirect to="/setup/user"/>
    }

    if (this.props.location.state === undefined) {
      return <Redirect to="/404" />
    }

    const profile = this.props.location.state.profile
    const person = this.props.location.state.person
    const arriving_app_id = this.props.location.state.arriving_app_id
    const planned_event_ids = this.props.location.state.planned_event_ids

    const destinationSwitch = new DestinationSwitch({ current_page: "group-arrivals", profile: profile, person: person, arriving_app_id: arriving_app_id, direction: "arriving", planned_event_ids: planned_event_ids });

    if (this.state.validDetails || this.state.skip) {
      return destinationSwitch.redirect()
    }

    const submit_button_value = destinationSwitch.buttonName()

    return (
      <div className="main-page group-arrivals-page back-button">
        <InteractionTimeout seconds={60} />

        <SetTitle title={"Group Arrival"} />
        <HeaderText />

        {this.renderGroupCheck()}
        {this.renderGroupArrivalForm(submit_button_value)}

        <div></div>
      </div>
    );
  }
}

export default GroupArrival;
